import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCheckCircle, FaCrown } from 'react-icons/fa'

const WhoWeAreArea = () => {
  const { t } = useTranslation()
  const ourValues = t('who-we-are-values', { returnObjects: true })

  /*
  "who-we-are-title": "Who We Are",
  "who-we-are-mission-title": "Mission",
  "who-we-are-mission": "To be the trusted partner for businesses seeking cutting-edge digital solutions. Through expertise, creativity, and commitment to excellence, we drive growth, efficiency, and success for our clients.",
  "who-we-are-vision-title": "Vision",
  "who-we-are-vision": "Revolutionize the digital landscape by delivering innovative solutions that empower businesses to thrive in the digital age.",
  */

  return (
    <>
      {/* who we are area start */}
      <div className="who-we-are-section pd-top-120 ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center">
                <h2 className="title">
                  The Power Of <span>Software</span> The Simplicity Of Solutions
                </h2>
              </div>
            </div>
          </div>
          <div className="who-we-are-wrap-area">
            <nav>
              <div
                className="nav nav-tabs who-we-are-nav-tab"
                id="nav-tab"
                role="tablist"
              >
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  id="nav-who-we-are-tab"
                  data-bs-target="#nav-who-we-are"
                  aria-controls="nav-who-we-are"
                  aria-selected="true"
                >
                  {t('who-we-are-title')}
                </button>
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  id="nav-mission-tab"
                  data-bs-target="#nav-mission"
                  aria-controls="nav-mission"
                  aria-selected="false"
                >
                  {t('who-we-are-mission-title')}
                </button>
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  id="nav-vision-tab"
                  data-bs-target="#nav-vision"
                  aria-controls="nav-vision"
                  aria-selected="false"
                >
                  {t('who-we-are-vision-title')}
                </button>
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  id="nav-values-tab"
                  data-bs-target="#nav-values"
                  aria-controls="nav-values"
                  aria-selected="false"
                >
                  {t('who-we-are-values-title')}
                </button>
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                  id="nav-industries-tab"
                  data-bs-target="#nav-industries"
                  aria-controls="nav-industries"
                  aria-selected="false"
                >
                  {t('who-we-are-industries-title')}
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-who-we-are"
                role="tabpanel"
                aria-labelledby="nav-who-we-are"
              >
                <div className="who-we-are-wrap">
                  <div className="row">
                    <div className="col-lg-5">
                      <img src="assets/images/whoweare.png" alt="img" />
                    </div>
                    <div className="col-lg-7">
                      <p className="mb-3">{t('about-us-specialization')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-mission"
                role="tabpanel"
                aria-labelledby="nav-mission-tab"
              >
                <div className="who-we-are-wrap">
                  <div className="row">
                    <div className="col-lg-5">
                      <img src="assets/images/mission.png" alt="img" />
                    </div>
                    <div className="col-lg-7">
                      <p className="mb-3">{t('who-we-are-mission')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-vision"
                role="tabpanel"
                aria-labelledby="nav-vision-tab"
              >
                <div className="who-we-are-wrap">
                  <div className="row">
                    <div className="col-lg-5">
                      <img src="assets/images/vision.png" alt="img" />
                    </div>
                    <div className="col-lg-7">
                      {/* <h3 className="mb-3">{t('who-we-are-')}</h3> */}
                      <p className="mb-3">{t('who-we-are-vision')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-values"
                role="tabpanel"
                aria-labelledby="nav-values-tab"
              >
                <div className="who-we-are-wrap">
                  <ul className="row single-list-inner style-check style-heading style-check mb-3">
                    {Object.keys(ourValues).map((key) => (
                      <li key={key} className="col-md-6">
                        <FaCrown className="alignleft icon-align-middle" />
                        <strong>{key}</strong>
                        <br />
                        {ourValues[key]}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav-industries"
                role="tabpanel"
                aria-labelledby="nav-industries-tab"
              >
                <div className="who-we-are-wrap">
                  <div className="row">
                    <h3 className="mb-3">{t('who-we-are-industries')}</h3>
                  </div>
                  <ul className="row single-list-inner style-check style-heading style-check mb-3">
                    {t('about-us-industries', { returnObjects: true }).map(
                      (item) => (
                        <li key={item} className="col-md-3">
                          <FaCheckCircle /> {item}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* who we are area start */}
    </>
  )
}

export default WhoWeAreArea
